import { Component, Renderer2, ViewChild, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { TransferFlyoutComponent } from '../transfer-flyout/transfer-flyout.component';
import { PayoutTokensService } from 'src/app/shared/services/api/get-payout-tokens.service';
import { WalletSummaryService } from 'src/app/shared/services/api/wallet-summary.service';
import { WalletSummary } from 'src/app/shared/models/wallet-summary.interface';
import { BankDetails, DWPayoutToken, PayoutTokens, PayoutTokensResponse, transferCarrier } from 'src/app/shared/models/payouttokens.model';
import { CurrencyPipe, DatePipe, formatCurrency } from '@angular/common';
import { GetGuidService } from 'src/app/shared/services/api/get-guid.service';
import { DWDPATSessionModel, PPIStartWalletSession } from 'src/app/shared/models/session.model';
import { ApiEndpoints } from 'src/config/api-endpoints';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DynamicPopupComponent } from 'src/app/shared/components/dynamic-popup/dynamic-popup';
import { AutoTransfer, DWSetAutoTransferRequest, DWSetAutoTransferResponse } from 'src/app/shared/models/AutoTransfer.model';
import { TransferPopUpComponent } from '../transfer-pop-up/transfer-pop-up.component';
import { AutoTransferService } from 'src/app/shared/services/api/auto-transfer.service';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-transfer-balance',
  templateUrl: './transfer-balance.component.html',
  styleUrls: ['./transfer-balance.component.scss']
})
export class TransferBalanceComponent implements OnInit, OnDestroy {
  [x: string]: any;
  @ViewChild('slide')
  matSlideToggle: MatSlideToggle;

  currentBalance: string = '';
  cashBalance: string = '';
  amount: string = '';
  paymenttokens: DWPayoutToken[] = [];
  payoutaccounts: any;
  selectedtoken: string = '';
  showzelle: boolean = false;
  noninstantdiv: any;
  instantdiv: any;
  errorMessage: any = '';
  validationMessage: any = '';

  amountChanged: boolean = false;

  walletSummary: WalletSummary | null = null;
  walletId: string = '';
  walletRole: string = '';
  autoPay: number = 0;
  autoTransfer: boolean;
  dwdpatsession: any;
  nopayments: boolean = true;
  errorMessageVisible: boolean = false; // Initially hidden

  //@ViewChild(TransferFlyoutComponent, { static: true }) transferFlyoutComponent!: TransferFlyoutComponent;
  walletDetails: any;
  isLastOption: boolean = false;
  rewardsBalance: string = '';
  loading: boolean = true;
  holdbtn: boolean = false;
  lastTransferType: string = '';

  showBanner: boolean = true;
  autoTransferToggle: boolean;
  toggleText: string = 'Off'; 
  NoAccountsAT :boolean;
  ATValidationMsg:string='';
  //showATRTPMessage:boolean=false;
  sessionobj:any='';
isPPI:boolean=false;
  constructor(public sessionservice: GetGuidService, public route: Router, private renderer: Renderer2, private el: ElementRef, public payouttokens: PayoutTokensService, public routeActivate: ActivatedRoute, public walletSummaryService: WalletSummaryService, public dialog: MatDialog,public sessionServiceAPI: SessionService,
    public autotransferservice:AutoTransferService) {
      this.walletRole = JSON.parse(sessionStorage.getItem("WalletRole"));
      this.isPPI = this.sessionServiceAPI.isPPI()?? false;
  }


  ngAfterContentInit() {
    
    this.getpayouttokens();
    /* let amt = this.cashBalance.toString().replace(/^\$/, '').replaceAll(",", "");
    if(parseFloat(amt)<=3.00)
    {
    this.showATRTPMessage=true;
    this.ATValidationMsg="Instant Transfer cannot be processed for cash balance less than $3.00";
    } */
    this.updateBalance();

  }

  ngAfterContentChecked(){
    this.updateBalance();
  }

  ngAfterViewChecked() {
    this.noninstantdiv = document.getElementById('non-instant');
    this.instantdiv = document.getElementById('instant');
    this.instantdiv?.classList.add('selected');
    this.noninstantdiv?.classList.remove('selected');
    if (this.lastTransferType == 'NonRTP') {
      this.noninstantdiv?.classList.add('selected');
      this.instantdiv?.classList.remove('selected');
    }
    else {
      this.instantdiv?.classList.add('selected');
      this.noninstantdiv?.classList.remove('selected');
    }
    
  }

  removeAlpha(): void {
    if (!this.amount) return;
  
    // Remove non-numeric characters except the decimal point
    this.amount = this.amount.replace(/[^0-9.]/g, '');
  
    // Prevent multiple decimals
    const decimalCount = (this.amount.match(/\./g) || []).length;
    if (decimalCount > 1) {
      this.amount = this.amount.substring(0, this.amount.length - 1);
    }
  
    // Limit to 2 decimal places
    if (this.amount.includes(".")) {
      const [integerPart, decimalPart] = this.amount.split(".");
      this.amount = `${integerPart}.${decimalPart.substring(0, 2)}`;
    }
  
    // Enforce max value to currentBalance
    const numericAmount = parseFloat(this.amount);
    const maxAllowed = parseFloat(this.currentBalance);
    if (!isNaN(numericAmount) && numericAmount > maxAllowed) {
      this.amount = maxAllowed.toFixed(2);
    }
  
    this.amountChanged = true;
  }
  
  

  restrictToNumbers(event: KeyboardEvent): boolean {
    const key = event.key;
    
    // Get current input value
    let currentValue = this.amount || "";
  
    // Allow: Numbers (0-9), Backspace, Delete, Arrow Keys, Tab
    if (
      /^[0-9]$/.test(key) ||  
      key === "Backspace" ||
      key === "Delete" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "Tab"
    ) {
      return true;
    }
  
    // Allow only one decimal point
    if (key === "." && !currentValue.includes(".")) {
      return true;
    }
  
    // Prevent typing more than 2 decimal places
    if (currentValue.includes(".")) {
      const [integerPart, decimalPart] = currentValue.split(".");
      
      // If decimalPart already has 2 digits, block further input
      if (decimalPart?.length >= 2) {
        event.preventDefault();
        return false;
      }
    }
  
    // Block everything else
    event.preventDefault();
    return false;
  }

  restrictDecimalPlaces(event: any): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const decimalPart = value.split('.')[1];
  
    if (decimalPart && decimalPart.length > 2) {
      input.value = value.slice(0, value.indexOf('.') + 3);
    }
  }


  
  
  handlePaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
  
    // Allow only numbers with up to 2 decimal places
    if (!/^\d+(\.\d{0,2})?$/.test(pastedText)) {
      event.preventDefault(); // Block invalid pastes
    }
  }
  

  // ngOnInit(): void {
  //   // Check Auto-Transfer status from sessionStorage
  //   const autoTransferData = JSON.parse(sessionStorage.getItem('AutoTransfer') || '{}');

  //   console.log("Const AutoTrasnferData:", autoTransferData);
  //   if (autoTransferData && autoTransferData.isAutoTransfer) {
  //     this.autoTransferToggle = true;
  //     this.selectedtoken = autoTransferData.defaultToken;\]
  //     this.lastTransferType = autoTransferData.transferType;
  //   } else {
  //     this.autoTransferToggle = false;
  //   }
  
  //   console.log("Transfer Balance Auto Transfer Toggle State: ", this.autoTransferToggle);

  //     // Retrieve wallet details from sessionStorage
  // this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails') || '{}');
  // if (this.walletDetails) {
  //   this.cashBalance = parseFloat(this.walletDetails.cash.totalCashBalance.toString()).toFixed(2);
  //   this.currentBalance = parseFloat(this.cashBalance.toString()).toFixed(2);
  //   this.amount = formatCurrency(
  //     parseFloat(parseFloat(this.currentBalance).toFixed(2)),
  //     'en-us',
  //     '$'
  //   );

  //     // Extract and set auto-transfer details
  //     const autoTransferDetails = this.walletDetails.autotransfer || {};
  //     this.autoTransferToggle = autoTransferDetails.isDWAutoTransfer === 'True';
  //     this.selectedtoken = autoTransferDetails.payeeID || '';
  //     this.lastTransferType = autoTransferDetails.autoTransferType || 'RTP';

  //      // Update sessionStorage with the correct AutoTransfer values
  //   sessionStorage.setItem(
  //     'AutoTransfer',
  //     JSON.stringify({
  //       isAutoTransfer: this.autoTransferToggle,
  //       transferType: this.lastTransferType,
  //       defaultToken: this.selectedtoken
  //     })
  //   );
  // } else {
  //   console.warn("No wallet details found in sessionStorage.");
  // }
  


  
  //   // Subscribe to wallet summary service
  //   this.walletSummaryService.walletSummary$.subscribe(summary => {
  //     this.walletSummary = summary;
  
  //     // Parse and assign wallet details
  //     this.currentBalance = parseFloat(summary?.wallet?.cash?.totalCashBalance).toFixed(2);
  //     this.cashBalance = parseFloat(summary?.wallet?.cash?.totalCashBalance).toFixed(2);
  //     this.amount = formatCurrency(
  //       parseFloat(parseFloat(summary?.wallet?.cash?.totalCashBalance).toFixed(2)),
  //       'en-us',
  //       '$'
  //     );
  //     this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;
  //     this.autoTransferToggle = summary?.wallet?.isDWAutoTransfer === 'True' || false;
  //     console.log('Auto Transfer state on load:', this.autoTransferToggle);
  //     this.rewardsBalance = parseFloat(summary?.wallet?.rewards?.totalRewardBalance).toFixed(2);
  
  //     console.log("AutoPay from Transfer Balance: ", this.autoPay);
  //   });

  //   // this.autoTransferToggle = this.walletSummary?.wallet?.isDWAutoTransfer === 'True';
  //   // this.selectedtoken = this.walletSummary?.wallet?.autotransfer?.payeeID || '';
  //   // this.lastTransferType = this.walletSummary?.wallet?.autotransfer?.autoTransferType || 'RTP';

  //   // console.log('Auto Transfer state from API:', this.autoTransferToggle);

  //   // sessionStorage.setItem(
  //   //   'AutoTransfer',
  //   //   JSON.stringify({
  //   //     isAutoTransfer: this.autoTransferToggle, // Derived from `autotransfer.isDWAutoTransfer`
  //   //     transferType: this.walletSummary?.wallet?.autotransfer?.autoTransferType || '',
  //   //     defaultToken: this.walletSummary?.wallet.autotransfer?.payeeID || ''
  //   //   })
  //   // );
    
  // }
  
  ngOnInit(): void {

    this.errorMessageVisible = false; // To ensure error message is hidden on page load
    
    // Check Auto-Transfer status from sessionStorage
    const autoTransferData = JSON.parse(sessionStorage.getItem('AutoTransfer') || '{}');
    console.log("Const AutoTransferData:", autoTransferData);
    if (autoTransferData && autoTransferData.isAutoTransfer!=undefined&& autoTransferData.isAutoTransfer.toString().toLowerCase()=="true"?true:false){
      this.route.navigate(['my-wallet', 'my-cash', 'auto-transfer']);
      this.autoTransferToggle = true;
      this.selectedtoken = autoTransferData.defaultToken=="0"?"":autoTransferData.defaultToken;
      this.lastTransferType = autoTransferData.transferType;
    } else {
      this.autoTransferToggle = false;
      
    }

    console.log("Transfer Balance Auto Transfer Toggle State: ", this.autoTransferToggle);

    // Retrieve wallet details from sessionStorage
    this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails') || '{}');
    
    if (this.walletDetails) {
      
      this.cashBalance = parseFloat(this.walletDetails.cash.totalCashBalance.toString()).toFixed(2);
      this.currentBalance = parseFloat(this.cashBalance.toString()).toFixed(2);

    //   if (this.cashBalance === '0.00') {
    //     this.amount = '$0.00';
    // } else {
    //     this.amount = formatCurrency(parseFloat(this.currentBalance), 'en-us', '$');
    // }

    if (this.cashBalance === '0.00') {
      this.amount = '$0.00';
      this.validationMessage = "Your balance is $0.00. Please enter an amount less than or equal to your balance.";
  } else {
      this.amount = formatCurrency(parseFloat(this.currentBalance), 'en-us', '$');
      this.validationMessage = "";
  }

      this.amount = formatCurrency(
        parseFloat(parseFloat(this.currentBalance).toFixed(2)),
        'en-us',
        '$'
      );

      // Extract and set auto-transfer details
      const autoTransferDetails = this.walletDetails.autotransfer || {};
      this.autoTransferToggle = autoTransferDetails.isDWAutoTransfer === 'True';
      this.selectedtoken = autoTransferDetails.payeeID || '';
      this.lastTransferType = autoTransferDetails.autoTransferType || 'RTP';

      // Update sessionStorage with the correct AutoTransfer values
      
    } else {
      console.warn("No wallet details found in sessionStorage.");
    }
    this.walletID = JSON.parse(sessionStorage.getItem("WalletID") || '{}');
    this.walletRole = JSON.parse(sessionStorage.getItem("WalletRole") || '{}');
    // Subscribe to wallet summary service
    this.walletSummaryService.fetchWalletSummary(this.walletID,this.walletRole).subscribe(summary => {
      if(summary!=null){
      this.walletSummary = summary;

      // Parse and assign wallet details
      this.currentBalance = parseFloat(summary?.wallet?.cash?.totalCashBalance).toFixed(2);
      this.cashBalance = parseFloat(summary?.wallet?.cash?.totalCashBalance).toFixed(2);
      this.amount = formatCurrency(
        parseFloat(parseFloat(summary?.wallet?.cash?.totalCashBalance).toFixed(2)),
        'en-us',
        '$'
      );
      this.autoPay = Number(this.walletSummary?.wallet.isDWAutoPay) || 0;
      this.autoTransferToggle = summary?.wallet?.isDWAutoTransfer === 'True' || false;
      console.log('Auto Transfer state on load:', this.autoTransferToggle);
      this.rewardsBalance = parseFloat(summary?.wallet?.rewards?.totalRewardBalance).toFixed(2);

      console.log("AutoPay from Transfer Balance: ", this.autoPay);
      }
    });

    this.autoTransferToggle = this.walletSummary?.wallet?.isDWAutoTransfer === 'True';
    this.selectedtoken = this.walletSummary?.wallet?.autotransfer?.payeeID || '';
    this.lastTransferType = this.walletSummary?.wallet?.autotransfer?.autoTransferType || 'RTP';
    console.log('Auto Transfer state from API:', this.autoTransferToggle);
    /* sessionStorage.setItem(
      'AutoTransfer',
      JSON.stringify({
        isAutoTransfer: this.autoTransferToggle,
        transferType: this.lastTransferType,
        defaultToken: this.selectedtoken
      })
    ); */
    this.nopayments = !this.payoutaccounts || this.payoutaccounts.length === 0;
  }

  // Method to handle changes in payeeID and isAutoTransfer
  updateAutoTransferValues(): void {
    sessionStorage.setItem(
      'AutoTransfer',
      JSON.stringify({
        isAutoTransfer: this.autoTransferToggle,
        transferType: this.lastTransferType,
        defaultToken: this.selectedtoken
      })
    );
  }

  // Call this method whenever the user changes the payeeID or isAutoTransfer values
  onPayeeIDChange(newPayeeID: string): void {
    this.selectedtoken = newPayeeID;
    this.updateAutoTransferValues();
  }

  onAutoTransferToggleChange(newStatus: boolean): void {
    this.autoTransferToggle = newStatus;
    this.updateAutoTransferValues();
  }

  getpayouttokens() {
    let payouttokens: PayoutTokens = new PayoutTokens();
    let transferType: any;
    if (document.getElementById('instant') == null) {
      transferType = 'RTP';
      this.lastTransferType = 'RTP';
    }
    else if (document.getElementById('instant')?.classList.contains('selected')) {
      transferType = 'RTP';
      this.lastTransferType = 'RTP';
    }
    else {
      transferType = 'NonRTP';
      this.lastTransferType = 'NonRTP';
    }
    payouttokens.transferType = transferType;
    payouttokens.walletID = JSON.parse(sessionStorage.getItem("WalletID") || '{}');
    payouttokens.walletRole = JSON.parse(sessionStorage.getItem("WalletRole") || '{}');
    payouttokens.sessionID = sessionStorage.getItem("SessionID");

    let listoftokens = this.payouttokens.fetchpayouttokens(payouttokens, this.isPPI).subscribe({
      next: (data: PayoutTokensResponse) => {

        this.nopayments = true;
        if (data.success == true)
          this.nopayments = false;
        this.paymenttokens = data.payoutTokens;
        this.paymenttokens.forEach((token: any) => {

          if (token.zelleIndicator == 'T') {
            token.cardImg = this.payouttokens.getcardImage('zelle');

          }
          else {
            token.counterpartyPayOrg = token.counterpartyPayOrg.replace('NA', '');
            token.cardImg = this.payouttokens.getcardImage(token.counterpartyPayOrg);
            if (token.counterPartyAccountNumber != null && token.counterPartyAccountNumber != undefined) {
              let accnumber = token.counterPartyAccountNumber;
              token.counterPartyAccountNumber = accnumber.substring(accnumber.length - 4, accnumber.length + 1);
            }
            else {
              token.counterPartyAccountNumber = '0000';
            }
          }
          /*  let expiration=token.ccexpiration;
           token.ccexpiration=expiration.slice(4,6)+"/"+ expiration.slice(2,4) */
        });

        this.instantaccounts = this.paymenttokens.filter((x: any) => x.achIndicator == 'T');
        this.zelleaccounts = this.paymenttokens.filter((x: any) => x.achIndicator == 'F');
        this.payoutaccounts = this.paymenttokens.sort((x:any,y:any)=>parseInt(y.payeeID)-parseInt(x.payeeID));
        if (this.payoutaccounts.length > 0) {
          this.payoutaccounts[this.payoutaccounts.length - 1].isLastOption = true;
          this.selectedtoken=this.payoutaccounts[0].payeeID;
          
        }
        this.loading = false;


      }

    });
    this.updateBalance();

  }

  ngOnDestroy(): void {

  }
  clearAmount(): void {
    this.amount = "$";
  }

  updateBalance(): void {

    if (this.amountChanged) {
      this.formatAmount(); // Format only if amount has changed
      this.amountChanged = false; // Reset the flag
    }
    
    

// VALIDATION AND ERROR HANDLING
const transferBtn = document.getElementById("transferbtn");
const inputSection = document.getElementById("inputsection");
const underline = document.getElementsByClassName("underline")[0];
const cashBalanceElement = document.getElementById("cashbalance");
const clearIcon = document.getElementsByClassName("clear-icon")[0];

if (!transferBtn) return;

let amt = this.amount.replace(/[$,]/g, '').trim();
let parsedAmt = parseFloat(amt);

if ( !amt || isNaN(parsedAmt)) {
  this.setValidationState(true, "Please enter a valid amount.", transferBtn, inputSection, underline, cashBalanceElement, clearIcon);
  return;
}

if (parsedAmt === 0) {
  this.setValidationState(true, "Please enter an amount less than or equal to your balance.", transferBtn, inputSection, underline, cashBalanceElement, clearIcon, true);
  return;
}


if (parsedAmt < 0) {

  this.setValidationState(true, "Please enter an amount less than or equal to your balance.", transferBtn, inputSection, underline, cashBalanceElement, clearIcon);
  return;
}

if (parsedAmt > parseFloat(this.cashBalance)) {
  this.setValidationState(true, "Please type an amount less than your balance.", transferBtn, inputSection, underline, cashBalanceElement, clearIcon);
  return;
}

if (document.getElementById('instant')?.classList.contains('selected') && parsedAmt < 3) {
  this.setValidationState(true, "For Instant transfer, please enter an amount of $3.00 or more.", transferBtn, inputSection, underline, cashBalanceElement, clearIcon);
  return;
}

// ✅ SUCCESS: Enable button, remove error messages
this.setValidationState(false, "", transferBtn, inputSection, underline, cashBalanceElement, clearIcon);

  }

  private setValidationState(
    hasError: boolean, message: string, transferBtn: HTMLElement,
    inputSection: HTMLElement | null, underline: Element | undefined,
    cashBalanceElement: HTMLElement | null, clearIcon: Element | undefined,
    isWarning: boolean = false) {
    
    this.validationMessage = message;
    
    if (hasError) {
      inputSection?.classList.add("error");
      underline?.classList.add("error");
      cashBalanceElement?.classList.add("error");
      clearIcon?.classList.add("error");
      transferBtn.setAttribute('disabled', 'true');

      if (isWarning) {
        inputSection?.classList.add("warning");
        clearIcon?.classList.remove("error");
        underline?.classList.remove("error");
      } else {
        inputSection?.classList.remove("warning"); 
        clearIcon?.classList.add("error");
        underline?.classList.add("error");
      }
    }   // Apply 'warning' class if needed
   else {
      inputSection?.classList.remove("error");
      underline?.classList.remove("error");
      cashBalanceElement?.classList.remove("error");
      clearIcon?.classList.remove("error");
      transferBtn.removeAttribute('disabled');
    }
  }

  formatAmount(): void {
    if (!this.amount || this.amount === '.' || this.amount === '$') {
      this.amount = '';
      return;
    }

    let parsedAmount = parseFloat(this.amount);
    if (!isNaN(parsedAmount)) {
      this.amount = `$${parsedAmount.toFixed(2)}`;
    }
  }

  goToReview() {
    this.holdbtn = true;
    if (document.getElementById('non-instant')?.classList.contains('selected')) {
      let config = new MatDialogConfig();
      config.data = "NonInstantConfirmation";
      let dialogRef = this.dialog.open(DynamicPopupComponent, config);
      dialogRef.afterClosed().subscribe(
        result => {
          this.holdbtn = false;
          if (result == 'close') {

            this.reviewTranfer();
            //this.currentDefaultPaymentMethod = result; // User selected a payment method in the flyout, update to that method.
          }

        }
      );
    }
    else {
      this.reviewTranfer();
    }
  }
  reviewTranfer() {
    this.holdbtn = true;
    let transferType: any, charge: any, totaltransfer: any;
    let amt = this.amount.toString().replace(/^\$/, '').replaceAll(",", "");
    this.updateBalance();

    if (this.selectedtoken == "" || this.selectedtoken == undefined) {
      this.errorMessage = "Please select an account to transfer funds.";
      this.holdbtn = false;
      return
    }
    else {

      
      if (document.getElementById('instant')?.classList.contains('selected')) {
        transferType = 'RTP';
        let charge1 = (parseFloat(amt) * 0.015).toFixed(2);
        charge = formatCurrency(parseFloat(charge1), 'en-us', '$');
        let totaltransfer1 = (parseFloat(amt) - (parseFloat(amt) * 0.015)).toFixed(2);
        totaltransfer = formatCurrency((parseFloat)(totaltransfer1), 'en-us', '$');

      } else {
        transferType = 'NonRTP';
        charge = formatCurrency(0, 'en-us', '$');
        let totaltransfer1 = parseFloat(amt).toFixed(2).toString();
        totaltransfer = formatCurrency((parseFloat)(totaltransfer1), 'en-us', '$');
      }
      let objTransferCarrier: transferCarrier = new transferCarrier();
      let token: any = this.paymenttokens.filter((x: any) => x.payeeID == this.selectedtoken);



      let bankDetails: BankDetails = new BankDetails();
      if (token[0].achIndicator == 'T') {
        bankDetails.accountDetails = "Bank **** " + token[0].counterPartyAccountNumber;
        bankDetails.bankName = token[0].counterpartyPayOrg + " " + token[0].counterPartyBankAccountCategory + " Banking";
        bankDetails.imgSrc = token[0].cardImg;
      }
      else {
        bankDetails.accountDetails = token[0].counterPartyAccountNumber;
        bankDetails.bankName = "ZELLE";
        bankDetails.imgSrc = token[0].cardImg;
      }
      objTransferCarrier.token = this.selectedtoken;
      objTransferCarrier.accountType = transferType;
      objTransferCarrier.charges = charge;
      objTransferCarrier.totalTransferAmount = totaltransfer;
      objTransferCarrier.transferAmount = this.amount;
      objTransferCarrier.bankDetails = bankDetails;

      sessionStorage.setItem("transferCarrier", JSON.stringify(objTransferCarrier));
      this.route.navigate(['my-wallet', 'my-cash', 'review-summary']);
    }
  }

  // // If the autopay toggle is toggled on or off, check/uncheck all 3 autopay options
  // onToggleChange(event: any) {
  //   this.toggleText = this.autopayToggle ? 'On' : 'Off'; // autopayToggle variabe is automatically updated via ngModel
    
  //   // Update all 3 options to checked or unchecked based on the new autopayToggle value
  //   for (let i = 0; i < this.autopayOptions.length; i++) {
  //     this.autopayOptions[i].checked = this.autopayToggle;
  //   }
  // }

  // From Branch 1

// onToggleChange(event: any): void {
  
//   let transferType=document.getElementById('non-instant')?.classList.contains('selected') ? 'nonRTP' : 'RTP'
//   if (this.autoTransferToggle) {
//     if (!this.selectedtoken) {
//       this.autoTransferToggle = false;
//       this.errorMessage = 'Please select an account to set Auto Transfer.';
//           }
          
//         }
// else{
//     const dialogRef = this.dialog.open(TransferPopUpComponent, {
//       width: '832px',
//       data: {      
//         transferType: this.lastTransferType, // Pass transfer type
//         defaultToken: this.selectedtoken,   // Pass selected token
//       } // Pass any data to the modal if needed
//     });

//     dialogRef.afterClosed().subscribe((result) => {
//       if (result) {
//         // User confirmed "Yes"
//         const atransfer = {
//           defaultToken: this.selectedtoken,
//           isAutoTransfer: true,
//           transferType: transferType
//         };

//         sessionStorage.setItem('AutoTransfer', JSON.stringify(atransfer));
//         this.autotransferservice.setautotransfer(true,this.selectedtoken,atransfer.transferType).subscribe({next:(data:DWSetAutoTransferResponse)  => {
//         console.log(JSON.stringify(data));
//         }});
//         this.route.navigate(['my-wallet', 'my-cash', 'auto-transfer']);
//       } else {
//         // User canceled
//           this.autotransferservice.setautotransfer(false,this.selectedtoken,transferType).subscribe({next:(data:DWSetAutoTransferResponse)  => {
//             console.log(JSON.stringify(data));
//             }});
//         this.autoTransferToggle = false;
//       }
//     });
//   }}

// From Branch 2

  // onToggleChange(event: any) {
  //   this.toggleText = this.autoTransferToggle ? 'On' : 'Off'; 
  //   if(this.autoTransferToggle)
  //   {
  //     if (this.selectedtoken == "" || this.selectedtoken == undefined) {
  //       this.errorMessage = "Please select an account to set Auto Transfer.";
  //       this.autoTransferToggle=false;
  //       return
  //     }
  //     else{
  //     let atransfer= new AutoTransfer();
  //     atransfer.defaultToken=this.selectedtoken;
  //     atransfer.isAutoTransfer=true;
      
  //     if (document.getElementById('non-instant')?.classList.contains('selected'))
  //     {
  //       atransfer.transferType="nonRTP";
  //     }
  //     else
  //     {
  //       atransfer.transferType="RTP";
  //     }

      
  //     sessionStorage.setItem("AutoTransfer",JSON.stringify(atransfer));
  //     this.route.navigate(['my-wallet', 'my-cash', 'auto-transfer']);
  //   }
  //   }
   
  // }

  handleDisabledToggleClick(): void {
    if (this.nopayments) {
      this.errorMessageVisible = true; // Show error message when clicked
    }
  }
  

  onToggleChange(event: any): void {
    
    if (this.nopayments) {
      this.errorMessageVisible = true; // Show error message when user clicks
      this.autoTransferToggle = false; // Ensure toggle stays off
      return;
    }
      
    const transferType = document.getElementById('non-instant')?.classList.contains('selected')
      ? 'nonRTP'
      : 'RTP';
    if (this.autoTransferToggle) {
      
      const dialogRef = this.dialog.open(TransferPopUpComponent, {
        width: '832px',
        data: {
          transferType,
          currentStatus: this.autoTransferToggle,
          defaultToken:this.selectedtoken
        }
      });
  
      dialogRef.afterClosed().subscribe((confirmed) => {
        if (confirmed) {
          this.updateAutoTransfer(true, transferType);
        } else {
          this.autoTransferToggle = false; // Revert toggle
        }
      });
    } 
  else {
      
      this.updateAutoTransfer(false, transferType);
    }
  
}
  
  updateAutoTransfer(status: boolean, transferType: string): void {
    const request = {
      walletID: JSON.parse(sessionStorage.getItem('WalletID')!),
      walletRole: JSON.parse(sessionStorage.getItem('WalletRole')!),
      isDWAutoTransfer: status,
      transferType
    };
    this.walletSummaryService.fetchWalletSummary(request.walletID,request.walletRole).subscribe(summary => {
      if (summary && summary.wallet) {
    this.autotransferservice.setautotransfer(status, this.selectedtoken, transferType,summary.wallet?.cash.totalCashBalance).subscribe({
      next: (response) => {
        console.log(`Auto Transfer ${status ? 'enabled' : 'disabled'} successfully.`);
       let account= this.payoutaccounts.filter(x=>x.payeeID==this.selectedtoken);
        sessionStorage.setItem(
          'AutoTransfer',
          JSON.stringify({ isAutoTransfer: status, transferType,defaultToken:this.selectedtoken,accountnumber:
          account[0].counterPartyAccountNumber, bankname:account[0].counterpartyPayOrg })
        );
      },
      error: (error) => {
        console.error('Failed to update Auto Transfer:', error);
        this.autoTransferToggle = !status; // Revert toggle
      }
    });
  }});
  }
  

  selectedtile(isinstant: boolean): void {
    let instantdiv, noninstantdiv;
    this.NoAccountsAT=false;
    if(this.matSlideToggle.checked){
    this.matSlideToggle.checked=false;
    this.autoTransferToggle=false;}
    this.loading = true;
    if (isinstant) {
      this.showzelle = false;
      this.noninstantdiv?.classList.remove('selected');
      this.instantdiv?.classList.add('selected');


    }
    else {
      this.showzelle = true;
      this.instantdiv?.classList.remove('selected');
      this.noninstantdiv?.classList.add('selected');


    }
    this.getpayouttokens();
  }

  gotoPayMyBill() {

    this.route.navigate(['/my-wallet/all-rewards/redeem'], { relativeTo: this.routeActivate });
  }
  addPaymentMethod(): void {
    this.holdbtn = true;

    if (sessionStorage.length > 0) {
      this.WalletID = JSON.parse(sessionStorage.getItem("WalletID") || '{}');
      this.sessionobj=JSON.parse(sessionStorage.getItem('ONLWalletSession') || '{}');
      if(this.isPPI)
      {
        this.sessionobj=JSON.parse(sessionStorage.getItem('PPIWalletSession') || '{}');
      }
    }

    let sessionID=sessionStorage.getItem("SessionID");
    let isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;

    this.dwdpatsession = new DWDPATSessionModel()
    this.dwdpatsession.action = 'addpayoutpayment';
    this.dwdpatsession.callBackURL = `${ApiEndpoints.startWalletSessionCallBack}/my-wallet/my-cash/transfer-balance`;
    this.dwdpatsession.country = 'US';
    this.dwdpatsession.createdByUserId = 'appdw';
    this.dwdpatsession.locale = 'en';
    this.dwdpatsession.navigatingSystem = 'dw';
    this.dwdpatsession.paymentDirection = 'payout';
    this.dwdpatsession.walletID = this.WalletID;
    this.dwdpatsession.cashBalance = this.currentBalance;
    this.dwdpatsession.rewardsBalance = this.rewardsBalance;
    this.dwdpatsession.sessionID=sessionID;
    this.dwdpatsession.billingSystem=!this.isPPI?this.sessionobj.billingSystem:"ppi";
    this.dwdpatsession.payorID=!this.isPPI?this.sessionobj.payorID:"0";
    this.dwdpatsession.userEmail=this.sessionobj.userEmail;
    this.dwdpatsession.rewardsEligible=!isBilliant;
    this.sessionservice.createdwdpatwalletsession(this.dwdpatsession);

  }

  private buildDWDPATSession(): DWDPATSessionModel {
    let isBilliant=sessionStorage.getItem("isBilliant")!=null?sessionStorage.getItem("isBilliant").toLocaleLowerCase()=="true"?true:false:false;
  return {
    action: 'addpayoutpayment',
    navigatingSystem: 'dw',
    paymentDirection: 'payout',
    walletID: this.walletID,
    cashBalance: this.currentBalance,
    rewardsBalance: this.rewardsBalance,
    createdByUserId: 'appdw',
    sessionID: sessionStorage.getItem("SessionID") || '',
    billingSystem: !this.isPPI?this.sessionobj.billingSystem:"ppi",
    payorID: this.isPPI?this.sessionobj.payorID:0,
    userEmail: this.sessionobj.userEmail,
    locale: 'en',
    country: 'US',
    callBackURL: `${ApiEndpoints.startWalletSessionCallBack}/my-wallet/my-cash/transfer-balance`,
    rewardsEligible:!isBilliant
  };
}

private buildPPIWalletSession(): PPIStartWalletSession {
  return {
    action: "accesswallet",
    navigatingSystem: "ppi",
    navigatingSystemRole: this.walletRole,
    productSystem: "ppi",
    productSystemIdentifier1: this.walletDetails.customerID,
    productSystemIdentifier1Name: "customerID",
    userIdentifier1: this.walletDetails.userID,
    userIdentifier1Name: "userID",
    displayName: this.walletDetails.displayName,
    userEmail: this.walletDetails.userEmail,
    callBackURL: `${ApiEndpoints.startWalletSessionCallBack}/my-wallet/my-cash/transfer-balance`
  };
}



  blurRest() {
    let config = new MatDialogConfig();
    config.autoFocus = false;
    let dialogRef = this.dialog.open(TransferFlyoutComponent, config);
  }

  enableBtn() {

    this.errorMessage = '';
    this.matSlideToggle.checked=false;
    this.autoTransferToggle=false;
    this.NoAccountsAT=false;
  }

  closeBanner(): void {
    this.showBanner = false;
  }
  /* closeatRTPMessage(): void {
    this.showATRTPMessage = false;
  } */

}
